<template>
  <div class="fullWidth">
    <div class="unitProductsEmpty">
      <br />
      <figure class="about-img2 img-wrapper">
        <img src="../assets/static/images/illustrations/inventoryCheck.svg" />
      </figure>
      <h2>{{ $t('obInventory') }}</h2>
    </div>

    <div class="activeClient">
      <v-container class="grey lighten-5">
        <v-row no-gutters>
          <v-col cols="12" sm="4" md="4">
            <v-card class="pa-2" outlined tile>
              <StockAlertTable
                :lowStockList="lowStockList"
                @change-stock="changeStockFromAlert"
              />
              <div class="toogle">
                <button
                  class="login-btn2"
                  @click="toggle('product')"
                  :class="[productStock ? 'active' : '']"
                >
                  {{ $t('productStock') }}
                </button>
                <br />
                <button
                  class="login-btn2"
                  @click="toggle"
                  :class="[!productStock ? 'active' : '']"
                >
                  {{ $t('unitInventories') }}
                </button>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="8" md="8">
            <v-card class="pa-2" outlined tile>
              <div v-if="productStock">
                <section v-if="errored">
                  <p>{{ $t('fetchError') }}</p>
                </section>
                <section v-else>
                  <div v-if="loading">{{ $t('loading') }}</div>
                  <!-- Responsive & Accessible Data Table  -->
                  <div v-else class="container">
                    <div>
                      <SearchFilter
                        v-if="
                          !(
                            isSearchResult === false &&
                            productStockList.length === 0
                          )
                        "
                      />
                      <div
                        v-if="
                          isSearchResult === true &&
                            productStockList.length === 0
                        "
                      >
                        {{ $t('noSearchResult') }}
                      </div>
                    </div>
                    <div class="column">
                      <ProductStockCard
                        v-for="(product, index) in productStockList"
                        :key="index"
                        :product="product"
                        @unit-stock="checkUnitStock"
                        @edit-general-stock="openUpdateStockDialogue"
                        @open-product-inquiry-form="openProductInquiryForm"
                      />
                    </div>
                  </div>
                </section>
              </div>
              <div v-else>
                <section v-if="errored">
                  <p>{{ $t('fetchError') }}</p>
                </section>
                <section v-else>
                  <div v-if="loading">{{ $t('loading') }}</div>
                  <!-- Responsive & Accessible Data Table  -->
                  <div v-else class="container">
                    <div class="column">
                      <UnitStockCard
                        v-for="(unit, index) in unitInventoriesList"
                        :key="index"
                        :unit="unit"
                        @unit-inventory="openInventoryModal"
                      />
                    </div>
                  </div>
                </section>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <b-modal
        id="product-unit-stock"
        size="lg"
        body-class="hide-padding"
        hide-footer
        no-stacking
      >
        <template v-slot:modal-title>
          {{ $t('unitInventoryFor') }}: {{ unitProductData.name }}
        </template>
        <div>
          <table class="responsive-table">
            <thead>
              <tr>
                <th scope="col">{{ $tc('unit', 1) }}</th>
                <th scope="col">
                  {{ $t('currentStock') }} / {{ $t('maxStock') }}
                </th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(unitStock, index) in unitProductData.unit_stock"
                :key="index"
              >
                <th scope="row">{{ unitStock.unit_name }}</th>
                <td :data-title="$t('currentStock')">
                  {{ unitStock.stock_curr }} / {{ unitStock.stock_max }}
                </td>
                <td data-title="">
                  <div
                    class="trash-Icon"
                    @click="
                      changeCurrentStock(
                        unitStock.unit_id,
                        unitStock.product_id,
                        unitStock.stock_curr,
                        unitProductData.stock_general,
                        unitStock.stock_max
                      )
                    "
                  >
                    <font-awesome-icon class="icon" icon="edit" />
                    <span class="changeStockMobile">{{
                      $t('changeStockModal')
                    }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-modal>
      <b-modal id="unit-inventory" size="lg" hide-footer no-stacking>
        <template v-slot:modal-title>
          {{ $t('unitInventoryIn') }}: {{ unitInventoryData.name }}
        </template>
        <div v-if="unitInventoryData.inventory_checked_at">
          {{ $t('lastInventoryCheck') }}: {{ unitInventoryData.inventory_checked_at | formatDate }} ({{ unitInventoryData.inventory_checked_by.firstName }} {{ unitInventoryData.inventory_checked_by.lastName }})
        </div>
        <div>
          <table class="responsive-table">
            <thead>
              <tr>
                <th scope="col">{{ $tc('product', 1) }}</th>
                <th scope="col">
                  {{ $t('currentStock') }} / {{ $t('maxStock') }}
                </th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(unitInventory,
                index) in unitInventoryData.product_stock"
                :key="index"
              >
                <th scope="row">{{ unitInventory.product_name }}</th>
                <td :data-title="$t('currentStock')">
                  {{ unitInventory.stock_curr }} / {{ unitInventory.stock_max }}
                </td>
                <td>
                  <div
                    class="trash-Icon"
                    style="text-align: center;"
                    @click="
                      changeCurrentStock(
                        unitInventory.unit_id,
                        unitInventory.product_id,
                        unitInventory.stock_curr,
                        unitInventory.stock_general,
                        unitInventory.stock_max
                      )
                    "
                  >
                    <font-awesome-icon class="icon" icon="edit" /><span
                      class="changeStockMobile"
                      >{{ $t('changeStockModal') }}</span
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-modal>
      <b-modal id="stock-update-modal" hide-footer>
        <template v-slot:modal-title>
          {{ $t('changeStockModal') }} {{ $t('in') }}:
          {{ unitInventoryData.name }}
        </template>
        <div class="stockInput">
          <label>{{ $t('stock') }}: </label>
          <input
            v-model="stock_curr"
            class="fieldPrice inp"
            :class="{ errorBg: $v.stock_curr.$error }"
            type="number"
            name="stock_curr"
            @blur="$v.stock_curr.$touch()"
            placeholder="50"
          />
          <span>{{ $t('pcs') }}</span>
          <div>
            {{ $t('generalStock') }}:
            {{ stock_general }}
            {{ $t('pcs') }}
          </div>
          <br />
          <template v-if="$v.stock_curr.$error">
            <p v-if="!$v.stock_curr.required" class="errorMessage">
              {{ $t('currentStockReq') }}
            </p>
            <p v-if="!$v.stock_curr.minValue" class="errorMessage">
              {{ $t('invalidValue') }}
            </p>
            <p v-if="!$v.stock_curr.maxValue" class="errorMessage">
              {{ $t('maxInvalidStockCurr') }}
            </p>
          </template>
          <template v-if="this.errors">
            <p v-if="this.errors" class="errorMessage">
              {{ this.errors }}
            </p>
          </template>
          <p>
            <button
              class="login-btn"
              sytle="text-transform: uppercase;"
              :disabled="$v.$invalid"
              @click="updateStock({ stock_curr: stock_curr })"
            >
              {{ $t('changeStockModal') }}
            </button>
          </p>
        </div>
      </b-modal>
      <b-modal id="general-stock-update-modal" hide-footer>
        <template v-slot:modal-title>
          {{ $t('changeOverallStockModal') }}
        </template>
        <div class="stockInput">
          <label>{{ $t('stock') }}</label>
          <input
            v-model="stock_general"
            class="fieldPrice inp"
            :class="{ errorBg: $v.stock_general.$error }"
            type="number"
            name="stock_general"
            @blur="$v.stock_curr.$touch()"
            placeholder="50"
          />
          <span>{{ $t('pcs') }}</span>
          <template v-if="$v.stock_general.$error">
            <p v-if="!$v.stock_general.required" class="errorMessage">
              {{ $t('overallStockReq') }}
            </p>
          </template>
          <p>
            <button
              class="login-btn"
              sytle="text-transform: uppercase;"
              @click="updateGeneralStock({ stock_general: stock_general })"
            >
              {{ $t('changeStockModal') }}
            </button>
          </p>
        </div>
      </b-modal>
    </div>

    <b-modal id="product-inquiry-modal" hide-footer>
      <template v-slot:modal-title>
        <!-- {{ $t('productInquiryForm') }} -->
      </template>
      <ProductInquiryForm
        :productDetails="currentProduct"
        :clientDetails="clientDetails[0]"
        :inquireDetails="inquireDetails"
        @hide-product-inquiry-form="hideProductInquiryForm"
      />
    </b-modal>
  </div>
</template>

<script>
import ProductStockCard from '@/components/ui/ProductStockCard.vue'
import UnitStockCard from '@/components/ui/UnitStockCard.vue'
import StockAlertTable from '@/components/ui/StockAlertTable.vue'
import SearchFilter from '@/components/common/SearchFilter.vue'
import ProductInquiryForm from '@/components/forms/ProductInquiryForm.vue'
import { required, minValue, maxValue } from 'vuelidate/lib/validators'
import moment from 'moment'

export default {
  metaInfo() {
    return {
      title: this.$i18n.t('inventory')
    }
  },
  filters: {
    formatDate: function(value) {
      if (value) {
        const utcDate = new Date(value)
        // Get local time zone offset in milliseconds
        const localOffset = new Date().getTimezoneOffset() * 60000
        // Convert UTC time to local time
        const localTime = new Date(utcDate.getTime() - localOffset)
        return moment(String(localTime)).format("HH:mm DD-MM-YYYY")
      }
    }
  },
  components: {
    ProductStockCard,
    UnitStockCard,
    StockAlertTable,
    SearchFilter,
    ProductInquiryForm
  },
  validations() {
    return {
      stock_curr: { required, minValue: minValue(0), maxValue: maxValue(this.maxStockCurr) },
      stock_general: { required }
    }
  },
  async created() {
    this.inquireDetails = JSON.parse(localStorage.getItem('user'))
    this.clientDetails = await this.$store.dispatch(
      'client/fetchClient',
      this.inquireDetails.id
    )
  },
  data() {
    return {
      loading: true,
      errored: false,
      productInfo: [],
      id: this.client.id,
      productStock: true,
      productStockList: [],
      unitInventoriesList: [],
      unitProductData: {},
      unitInventoryData: {},
      stock_curr: 0,
      stock_general: 0,
      unitId: 0,
      productId: 0,
      lowStockList: [],
      errors: null,
      isSearchResult: false,
      inquireDetails: {},
      clientDetails: [],
      currentProduct: {},
      maxStockCurr: 0
    }
  },
  async mounted() {
    await this.callAllStockAPIs()
    this.isSearchResult = false
  },
  methods: {
    toggle(type) {
      if (type === 'product') this.productStock = true
      else this.productStock = false
    },
    checkUnitStock(unitProductData) {
      this.unitProductData = unitProductData
      this.$bvModal.show('product-unit-stock')
    },
    openInventoryModal(unitInventoryData) {
      this.unitInventoryData = unitInventoryData
      this.$bvModal.show('unit-inventory')
    },
    openUpdateStockDialogue(product) {
      this.productId = product.id
      this.stock_general = product.stock_general
      this.$bvModal.show('general-stock-update-modal')
    },
    async updateStock(stockJson) {
      await this.$store
        .dispatch('unitProduct/editUnitProductStock', {
          unit_id: this.unitId,
          product_id: this.productId,
          ...stockJson
        })
        .then(async () => {
          await this.callAllStockAPIs()
          this.$bvModal.hide('stock-update-modal')
          this.errors = null
        })
        .catch(err => {
          if (err.response.data === 'stock_unavailable')
            this.errors = this.$t('noProductStock')
          else this.errors = err.response.data
        })
    },
    async updateGeneralStock(stockJson) {
      await this.$store.dispatch('product/editProduct', {
        id: this.productId,
        ...stockJson
      })
      await this.callAllStockAPIs()
      this.$bvModal.hide('general-stock-update-modal')
    },
    async callAllStockAPIs() {
      await Promise.all([
        this.getLowStockProduct(),
        this.fetchProductStock(),
        this.getUnitInventoryStock()
      ])
    },
    async getLowStockProduct() {
      await this.$store.dispatch(
        'unitProduct/getLowstockUnitProducts'
      ).then(response => {
        this.lowStockList = response
      })
    },
    async fetchProductStock() {
      await this.$store
        .dispatch('product/fetchProductStock')
        .then(response => {
          this.productStockList = response
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getUnitInventoryStock() {
      await this.$store
        .dispatch('unit/getUnitInventoryStock')
        .then(response => {
          this.unitInventoriesList = response
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    changeStockFromAlert(unitProduct) {
      this.changeCurrentStock(
        unitProduct.unit_id,
        unitProduct.product_id,
        unitProduct.stock_curr,
        unitProduct.stock_general,
        unitProduct.stock_max
      )
    },
    changeCurrentStock(unitId, productId, stock_curr, stock_general, stock_max) {
      this.stock_curr = stock_curr
      this.stock_general = stock_general
      this.unitId = unitId
      this.productId = productId
      this.errors = null
      this.maxStockCurr = stock_max
      this.$v.stock_curr.$params.maxValue = maxValue(this.maxStockCurr)
      this.$bvModal.show('stock-update-modal')
    },
    async searchTerm(search) {
      this.productStockList = await this.$store.dispatch(
        'product/searchProductStock',
        search
      )
      this.isSearchResult = true
    },
    openProductInquiryForm(data) {
      this.$bvModal.show('product-inquiry-modal')
      this.currentProduct = data.client
    },
    hideProductInquiryForm() {
      alert(this.$t('inquirySent'))
      this.$bvModal.hide('product-inquiry-modal')
    }
  },
  props: {
    client: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fullWidth {
  width: 100%;
}
.login-btn {
  color: var(--bg-light) !important;
  border: 1px solid var(--bg-light);
  background: none;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
  cursor: pointer;
}

.login-btn:hover {
  background: var(--bg-light);
  color: var(--bright) !important;
}
.login-btn2 {
  color: var(--bg-light);
  border: 1px solid var(--bg-light);
  background: none;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  margin: 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
  cursor: pointer;
}
.active {
  background: var(--bg-light) !important;
  color: var(--bright) !important;
  border: none !important;
}
.fieldPrice {
  width: 30%;
}

.inp {
  border: none;
  border-bottom: 0.2px solid var(--bg);
  padding: 5px 10px;
  outline: none;
  margin-bottom: 1.2em;
  background-color: var(--grey-superlight);
}
.inp:hover {
  border-color: var(--primaryDark);
}

[placeholder]:focus::-webkit-input-placeholder {
  transition: text-indent 0.4s 0.4s ease;
  text-indent: -100%;
  opacity: 1;
}

[v-cloak] {
  display: none;
}

.unitProductsEmpty {
  display: none; //! none when FIRST unitProduct with this client_id is already found in db //
}
.activeClient {
  // display: none; //! none when NO unitProduct with this client_id is found in db //
}

.btn {
  border: solid 1px var(--bg);
  color: var(--bg);
  font-weight: normal !important;
}

.errorMessage {
  margin-bottom: 0.2em;
  color: var(--primaryDark);
}

.product-cards {
  margin-top: 20px;
  margin-left: 0;
  padding-left: 0px;
}

.showOverall {
  border: none;
  color: var(--bright);
  background-color: var(--primaryDark) !important;
}

.about-img2 {
  display: inline-block;
  width: 100%;
  max-width: 500px;
  text-align: center;
  vertical-align: top;
}

.trash-Icon {
  background: var(--bg-superLight);
  color: var(--bright);
  padding: 0.3em;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 235px;
  height: 35px;
  right: 0;
  position: relative;
  text-align: left;
  cursor: pointer;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
}

.column {
  display: flex;
  flex-flow: wrap;
  height: 100%;
  justify-content: center;
}

@media (max-width: 500px) {
  .column {
    display: inherit;
  }
}

// Breakpoints
$bp-maggie: 15em;
$bp-lisa: 30em;
$bp-bart: 48em;
$bp-marge: 62em;
$bp-homer: 90em;

a {
  color: var(--primaryDark);

  &:hover,
  &:focus {
    color: var(--primaryDark);
  }
}

.container {
  // margin-bottom: 2em;

  @media (min-width: $bp-bart) {
    // margin: 2%;
  }

  @media (min-width: $bp-homer) {
    // margin: 2em auto;
    // max-width: $bp-homer;
  }
}

.responsive-table {
  width: 100%;
  margin-bottom: 1.5em;
  border-spacing: 0;

  @media (min-width: $bp-bart) {
    font-size: 0.9em;
  }

  @media (min-width: $bp-marge) {
    font-size: 1em;
  }

  thead {
    // Accessibly hide <thead> on narrow viewports
    position: absolute;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    padding: 0;
    border: 0;
    height: 1px;
    width: 1px;
    overflow: hidden;

    @media (min-width: $bp-bart) {
      // Unhide <thead> on wide viewports
      position: relative;
      clip: auto;
      height: auto;
      width: auto;
      overflow: auto;
    }

    th {
      background-color: var(--bg-light);
      border: 1px solid var(--bg-light);
      font-weight: normal;
      text-align: center;
      color: var(--bright);

      &:first-of-type {
        text-align: left;
      }
    }
  }

  // Set these items to display: block for narrow viewports
  tbody,
  tr,
  th,
  td {
    display: block;
    padding: 0;
    text-align: left;
    white-space: normal;
  }

  tr {
    @media (min-width: $bp-bart) {
      // Undo display: block
      display: table-row;
    }
  }

  th,
  td {
    padding: 0.5em;
    vertical-align: middle;

    @media (min-width: $bp-lisa) {
      padding: 0.75em 0.5em;
    }

    @media (min-width: $bp-bart) {
      // Undo display: block
      display: table-cell;
      padding: 0.5em;
    }

    @media (min-width: $bp-marge) {
      padding: 0.75em 0.5em;
    }

    @media (min-width: $bp-homer) {
      padding: 0.75em;
    }
  }

  caption {
    margin-bottom: 1em;
    font-size: 1em;
    font-weight: bold;
    text-align: center;

    @media (min-width: $bp-bart) {
      font-size: 1.5em;
    }
  }

  tfoot {
    font-size: 0.8em;
    font-style: italic;

    @media (min-width: $bp-marge) {
      font-size: 0.9em;
    }
  }

  tbody {
    @media (min-width: $bp-bart) {
      // Undo display: block
      display: table-row-group;
    }

    tr {
      margin-bottom: 1em;

      @media (min-width: $bp-bart) {
        // Undo display: block
        display: table-row;
        border-width: 1px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }

      &:nth-of-type(even) {
        @media (min-width: $bp-bart) {
          background-color: rgba(94, 93, 82, 0.1);
        }
      }
    }

    th[scope='row'] {
      background-color: var(--bg-light);
      color: white;

      @media (min-width: $bp-lisa) {
        border-left: 1px solid var(--bg-light);
        border-bottom: 1px solid var(--bg-light);
      }

      @media (min-width: $bp-bart) {
        background-color: transparent;
        color: rgba(94, 93, 82, 1);
        text-align: left;
      }
    }

    td {
      text-align: right;

      @media (min-width: $bp-bart) {
        border-left: 1px solid var(--bg-light);
        border-bottom: 1px solid var(--bg-light);
        text-align: center;
      }

      &:last-of-type {
        @media (min-width: $bp-bart) {
          border-right: 1px solid var(--bg-light);
        }
      }
    }

    td[data-type='currency'] {
      text-align: right;
    }

    td[data-title]:before {
      content: attr(data-title);
      float: left;
      font-size: 0.8em;
      color: rgba(94, 93, 82, 0.75);

      @media (min-width: $bp-lisa) {
        font-size: 0.9em;
      }

      @media (min-width: $bp-bart) {
        // Don’t show data-title labels
        content: none;
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .changeStockMobile {
    letter-spacing: 0;
    margin-left: 10px;
  }
  .trash-Icon {
    width: 175px;
  }
}
</style>
